import { Card, CardContent, CardHeader, CardTitle } from './ui/card';

export function TemporalAlignmentChart() {
  const alignmentData = [
    { time: '00:00', alignment: 65 },
    { time: '04:00', alignment: 78 },
    { time: '08:00', alignment: 85 },
    { time: '12:00', alignment: 92 },
    { time: '16:00', alignment: 88 },
    { time: '20:00', alignment: 75 },
    { time: '23:59', alignment: 70 }
  ];

  const maxAlignment = Math.max(...alignmentData.map(d => d.alignment));

  return (
    <Card className="bg-gradient-to-br from-purple-900/20 to-blue-900/20 border-purple-500/30">
      <CardHeader>
        <CardTitle className="text-purple-200">Temporal Alignment Trends</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="h-48 flex items-end space-x-2">
          {alignmentData.map((data, index) => (
            <div key={index} className="flex-1 flex flex-col items-center">
              <div 
                className="w-full bg-gradient-to-t from-purple-600 to-blue-500 rounded-t-sm transition-all duration-300 hover:from-purple-500 hover:to-blue-400"
                style={{ 
                  height: `${(data.alignment / maxAlignment) * 100}%`,
                  minHeight: '8px'
                }}
              />
              <div className="text-xs text-purple-400 mt-2 transform -rotate-45 origin-center">
                {data.time}
              </div>
              <div className="text-xs text-white font-medium mt-1">
                {data.alignment}%
              </div>
            </div>
          ))}
        </div>
        <div className="mt-4 text-center">
          <p className="text-sm text-purple-300">
            Current Alignment: <span className="text-white font-bold">88%</span>
          </p>
          <p className="text-xs text-purple-400">
            Peak alignment occurs during meditation hours
          </p>
        </div>
      </CardContent>
    </Card>
  );
}